import { createApp, h } from 'vue'
import ViewUIPlus, { Button as ViewUIButton } from 'view-ui-plus'
import App from './App.vue'
import router from './router'
import store from './store'
import './styles/index.less'
import './styles/aicare-theme.css'
import hljs from "highlight.js"
import 'highlight.js/styles/default.css';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import ClipboardJS from 'clipboard';
import VueVideoPlayer from '@videojs-player/vue'
import 'video.js/dist/video-js.css'
import VueClipboard from 'vue-clipboard2';
// import './mock'

const app = createApp(App)

const nativeButtonTypes = new Set(['button', 'submit', 'reset'])
const CompatibleButton = (props, { slots }) => {
  if (nativeButtonTypes.has(props.type)) {
    return h('button', props, slots.default ? slots.default() : [])
  }
  return h(ViewUIButton, props, slots)
}
CompatibleButton.inheritAttrs = false


// 定义自定义指令 highlight 代码高亮
app.directive('highlight', {
  mounted(el) {
    // 定义一个函数用于处理代码块
    const applyHighlightAndCopy = (el) => {
      let blocks = el.querySelectorAll('pre code');
      blocks.forEach((block) => {
        hljs.highlightBlock(block);

        // 检查容器是否已经存在
        if (!block.parentElement.classList.contains('code-container')) {
          // 创建包含代码块和按钮的容器
          let container = document.createElement('div');
          container.className = 'code-container';
          block.parentElement.replaceWith(container);
          container.appendChild(block.parentElement); // 移动 <pre> 到 container 内

          // 创建复制按钮
          let button = document.createElement('button');
          button.innerText = 'Copy';
          button.className = 'copy-button';
          container.appendChild(button);

          // 绑定 ClipboardJS
          new ClipboardJS(button, {
            target: () => block
          });

          button.addEventListener('click', () => {
            button.innerText = 'Copied!';
            setTimeout(() => {
              button.innerText = 'Copy';
            }, 2000);
          });
        }
      });
    };

    applyHighlightAndCopy(el);
  },
  updated(el) {
    // 定义一个函数用于处理代码块
    const applyHighlightAndCopy = (el) => {
      let blocks = el.querySelectorAll('pre code');
      blocks.forEach((block) => {
        hljs.highlightBlock(block);

        // 检查容器是否已经存在
        if (!block.parentElement.classList.contains('code-container')) {
          // 创建包含代码块和按钮的容器
          let container = document.createElement('div');
          container.className = 'code-container';
          block.parentElement.replaceWith(container);
          container.appendChild(block.parentElement); // 移动 <pre> 到 container 内

          // 创建复制按钮
          let button = document.createElement('button');
          button.innerText = 'Copy';
          button.className = 'copy-button';
          container.appendChild(button);

          // 绑定 ClipboardJS
          new ClipboardJS(button, {
            target: () => block
          });

          button.addEventListener('click', () => {
            button.innerText = 'Copied!';
            setTimeout(() => {
              button.innerText = 'Copy';
            }, 2000);
          });
        }
      });
    };

    applyHighlightAndCopy(el);
  }
});

app.use(store)
  .use(router)
  .use(ViewUIPlus)
  .use(ElementPlus)
  .use(VueClipboard)
  .use(VueVideoPlayer)

// 避免 Element Plus 的动态原生按钮被 ViewUIPlus 同名全局组件截获
app._context.components.Button = CompatibleButton

app.mount('#app')
